import { ComponentSingleStyleConfig } from '@chakra-ui/react'

export const TooltipStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    bg: 'blackAlpha.300',
    borderRadius: 'xl',
    maxW: '200px',
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}

export default TooltipStyles
